import { FC } from 'react'
import ReactLoading from 'react-loading'
import styled, { keyframes } from 'styled-components'

export const Loading: FC = () => {
  return (
    <StyledShadow>
      <div>
        <ReactLoading type="spin" color="#25a704" />
      </div>
    </StyledShadow>
  )
}

const fadeIn = keyframes`
  0% {
      opacity: 0;
    }
  100% {
    opacity: 1;
  }
`

const StyledShadow = styled.div`
  background: rgb(255 255 255 / 70%);
  width: 100%;
  transition: 0.2s;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 0.25s;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  svg {
    fill: #25a704;
  }
`
const StyledText = styled.p`
  text-align: center;
  color: #fff;
  padding-top: 10px;
`
